import { api } from "@/src/services/api";

export type NotificationAction = "read" | "unread" | "archive" | "restore";
export interface StudioNotification {
  id: string;
  category: "account" | "news";
  kind: "profile" | "integration" | "release";
  createdAt: string;
  values: Record<string, string>;
  readAt: string | null;
  archivedAt: string | null;
}

export const studioNotifications = {
  list: async () =>
    (await api.authGet<{ data: StudioNotification[] }>("/studio/notifications"))
      .data,
  update: (ids: string[], action: NotificationAction) =>
    api.authPatch("/studio/notifications", { ids, action }),
};
